import React, { useRef, useEffect, useState } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import {
  setTheInternalSubQuestionsEditionsActions,
  setTheinternalSubQuestionsRetrieveActions,
  setTheInternalSubQuestionsCreateActions,
} from "../../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

const InternalSubcategorycrud = (props) => {
  const { setShow, show, currentPage, EditID, ParentId, search ,Activeget } = props;
  const dispatch = useDispatch();

  const [ErrorInde, setErrInde] = useState(0);
  const state = useSelector((state) => state);
  const Headers = {
    name: "",
    description: "",
    issue_category_id: state.NeededdatasListed.SubQueryIDs,
    // expire_time: "",
    is_active: true,
    Priority: "",
    // TAT: ""
  };
  const [Data, setDatas] = useState(Headers);
  const [queryError, setqueryErr] = useState("");
  const [descriptionsErr, setDestionErr] = useState("");
  const [ExpireErr, setExpireErr] = useState("");
  const [prioritype, setpriority] = useState([]);
  const [priorityerr, setpriorityerr] = useState("");
  const [timeErr, setTimeErr] = useState("")
  let Priorityoptions = [
    {
      value: "0",
      label: "Low"
    },
    {
      value: "1",
      label: "Medium"

    },
    {
      value: "2",
      label: "High"

    }
  ]

  const [selectedTime, setSelectedTime] = useState("");

  // Generate 12-hour time options
  const generateTimeOptions = () => {
    const options = [];
    for (let h = 1; h <= 12; h++) {
      for (let m = 0; m < 60; m += 15) { // 15-minute intervals
        const hour = h.toString().padStart(2, "0");
        const minute = m.toString().padStart(2, "0");
        options.push(`${hour}:${minute} AM`);
        options.push(`${hour}:${minute} PM`);
      }
    }
    return options;
  };


  const inputRef = useRef()
  let currentDate = new Date();
  let year = currentDate.getFullYear();

  // Calculate the end of the current year
  let endOfYear = new Date(year, 11, 31); // December is 11th month (zero-based index)

  // Format the current date and end of year
  let currentMonth =
    (currentDate.getMonth() + 1 < 10 ? "0" : "") + (currentDate.getMonth() + 1);
  let currentDay =
    (currentDate.getDate() < 10 ? "0" : "") + currentDate.getDate();
  let formattedDate = `${year}-${currentMonth}-${currentDay}`;

  let endOfYearMonth =
    (endOfYear.getMonth() + 1 < 10 ? "0" : "") + (endOfYear.getMonth() + 1);
  let endOfYearDay =
    (endOfYear.getDate() < 10 ? "0" : "") + endOfYear.getDate();
  let formattedEndOfYear = `${year}-12-31`;

  const Handletoggle = (value) => {
    setDatas((prev) => {
      const updated = { ...prev, is_active: value };
      return updated;
    });

  };
  const HandlePriortyvalues = (e) => {
    setDatas({
      ...Data,
      Priority: e.value
    })
    setpriority(e)

  }

  useEffect(() => {
    if (EditID != undefined && EditID != "") {
      const payload = {
        EditID: EditID,
      };
      dispatch(setTheinternalSubQuestionsRetrieveActions(payload));
    }
  }, []);

  useEffect(() => {
    if (
      EditID != undefined &&
      EditID != ""
    ) {
      setDatas({
        ...Data,
        name: state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.name,
        description:
          state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.description,
        // expire_time:
        //   state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.expire_time,
        is_active: state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.is_active,
        Priority: state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.Priority,
        // TAT: state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.TAT != null && state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.TAT != undefined ?
          // state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.TAT : ""

      });
      if (state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.Priority != null && state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.Priority != undefined) {
        setpriority({
          value: state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.Priority, label: state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.Priority == "0" ? "LOW" :
            state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.Priority == "1" ? "MEDIUM" : state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve.Priority == "2" ? "HIGH" : ""
        })
      }
    }

  }, [state.InternalSubQuestionsRetrieve.InternalSubQuestionRetrieve, EditID]);

  const HandleChanges = (e) => {
    if (e.target.name == "TAT") {
      const { name, value } = e.target;

      setDatas((pre) => {
        return {
          ...pre,
          [name]: value,
        };
      });
    }

    // else if (e.target.name == "TAT") {
    //   const { name, value } = e.target;

    //   const [hour, minute] = value.split(":");
    //   const hours12 = ((+hour % 12) || 12).toString().padStart(2, "0");
    //   const ampm = +hour >= 12 ? "PM" : "AM";
    //   const formattedTime = `${hours12}:${minute} ${ampm}`;

    //   setDatas((prev) => ({
    //     ...prev,
    //     [name]: formattedTime,
    //   }));

    // }
    else {
      const { name, value } = e.target;

      setDatas((pre) => {
        return {
          ...pre,
          [name]: value,
        };
      });
    }
  };

  const HandleSubmits = (e) => {
    // e.preventDefault();
  };

  const HandleSubmit = (e) => {
    var a = 0;




    if (EditID == undefined || EditID == "") {

      if (Data.description == "") {
        setDestionErr("*Description is required");
        a = 1;
      }
      if (Data.name == "") {
        setqueryErr("*Subcategory is required");
        a = 1;
      }

      // if (Data.TAT == '') {
      //   a = 1;

      //   setExpireErr("*TAT is required");
      // }

      if (Data.Priority == "") {
        setpriorityerr("*Priority is required")
        a = 1
      }
      // if (Data.TAT == "" || Data.TAT == null || Data.TAT == undefined) {
      //   setExpireErr("*TAT is requried");
      //   a = 1;
      // }

      // if (Data.expire_time != "" && Data.expire_time < 28) {
      //   // a = 1;/
      //   setErrInde(0);

      //   setExpireErr("");
      // }

      if (a == 0 && ErrorInde == 0) {
        const payload = {
          currentPage: currentPage,
          Data: Data,
          category: state.NeededdatasListed.SubQueryIDs,
          search: search,
          Activeget:Activeget,

        };

        dispatch(setTheInternalSubQuestionsCreateActions(payload, setShow(false)));
      }
    } else if (EditID != undefined || EditID != "") {
      if (Data.description == "") {
        setDestionErr("*Description is required");
        a = 1;
      }
      if (Data.name == "") {
        setqueryErr("*Subcategory is required");
        a = 1;
      }

      // if (Data.expire_time == "") {
      //   a = 1;
      //   setExpireErr("* Expire Date is required");
      // }
      if (Data.Priority == "" && Data.Priority == null || Data.Priority == undefined) {
        setpriorityerr("*Priority is required")
        a = 1
      }

      // if (Data.TAT == "" || Data.TAT == null || Data.TAT == undefined) {
      //   setExpireErr("*Validity is requried");
      //   a = 1;
      // }

      // if (Data.expire_time != "" && Data.expire_time < 28) {
      //   // a = 1;/
      //   setErrInde(0);

      //   setExpireErr("");
      // }

      if (a == 0 && ErrorInde == 0) {
        const payload = {
          currentPage: currentPage,
          Data: Data,
          EditID: EditID,
          category: state.NeededdatasListed.SubQueryIDs,
          search: search,
          Activeget:Activeget,
          Rawdata: {
            name: Data.name,
            description: Data.description,
            issue_category_id: state.NeededdatasListed.SubQueryIDs,
            // expire_time: Data.expire_time,
            Priority: Data.Priority,
            // TAT: Data.TAT,
            is_active: Data.is_active

          }

        };

        dispatch(
          setTheInternalSubQuestionsEditionsActions(payload, setShow(false))
        );
      }
    }
  };








  const preventZoom = (event) => {
    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === "wheel")) {
      event.preventDefault();
    }

    // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
    if (["e", "E", "+", "-", "."].includes(event.key) || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData('text');

    // Strip non-numeric characters (except for digits)
    const filtered = paste.replace(/[^0-9]/g, '');

    // Prevent the default paste action and set the input value to the filtered result
    event.preventDefault();

    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic

  };




  const preventwheel = (event) => {
    if (event.target && event.target.className == "form-control" || event.target.class == "form-control") {
      event.preventDefault();
    }
  }



  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {

      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (event.target && event.target.className == "form-control" || event.target.class == "form-control") {
        event.preventDefault();
      }
    };
    if (inputElement) {

      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);


  const preventScrollNumbers = (e) => {
    e.preventDefault();
};
  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{ width: "40%" }}>
            <div className="asds">
              <div class="ModalHeader">
              <span className="UserCreate"> Subcategory </span>
                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>
              <form class="row g-3 form-fields-wrapper" onClick={HandleSubmits}>


                <div className="col-6 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Subcategory
                    <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={Data.name}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setqueryErr("");
                    }}
                    required
                    name="name"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{queryError}</p>
                </div>

           {/* <div className="col-6 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                  >
                    TAT
                    <span style={{ color: "red" }}>*</span>

                  </label>
                  <input
                       onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                          e.preventDefault();
                        }
                      }}
                      onFocus={(e) => {
                        e.target.addEventListener('wheel', preventScrollNumbers, {
                          passive: false,
                        });
                      }}
                      onBlur={(e) => {
                        e.target.removeEventListener('wheel', preventScrollNumbers);
                      }}
    
                    type="number"
                    class="form-control"
                    value={Data.TAT}
                    name="TAT"
                    autoComplete="off"
                    onChange={(e) => {
                      if (e.target.value > 28) {
                        e.preventDefault();

                        // setExpireErr(
                        //   "Expiration date should not exceed 28 digits."
                        // );
                        // setErrInde(1)
                      } else {
                        setExpireErr("");
                        HandleChanges(e);
                        setErrInde(0)
                      }
                    }}
                    required
                    // onKeyDown={(evt) => {
                    //   preventZoom(evt)

                    // }}
                    // onPaste={(evt) => handlePaste(evt)} // Handle pasting
                    // onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                    style={{
                      padding: "10px",
                    }}
                    // ref={inputRef}

                  ></input>



                  <p style={{ color: "red", marginTop: "5px" }}>{ExpireErr}</p>

                </div>  */}

                <div className="col-6  SelectedPriority" >
                  <label
                    for="validationCustom01"
                    class="form-label"
                  >
                    Priority
                    <span style={{ color: "red" }}>*</span>

                  </label>

                  <Select
                    className="Selects"

                    options={Priorityoptions}
                    onSelect={(e) => {
                      setpriority(e);
                    }}
                    value={prioritype}
                    onChange={(e) => {
                      HandlePriortyvalues(e);
                      setpriorityerr("")
                    }}
                    labelledBy="Select"


                  />
                  <p style={{ color: "red", marginTop: "5px" }}> {priorityerr} </p>
                </div>

                {/* 
                <div className="col-6  SelectedPriority" >
                  <label
                    for="validationCustom01"
                    class="form-label"
                  >
                    Turn around time
                    <span style={{ color: "red" }}>*</span>

                  </label>

                  <input type="time" class="form-control"
                    // value={Data.TAT}
                    value={Data.TAT.replace(/ (AM|PM)/, "")} // Display only the time part

                    name="TAT"
                    onChange={(e) => {
                      HandleChanges(e);
                      setTimeErr("");
                    }}

                  />
                  <p style={{ color: "red", marginTop: "5px" }}> {timeErr} </p>
                </div> */}
                {/* <div className="col-6">
                  <label
                    for="validationCustom01"
                    class="form-label"
                  >
                    Turn around Time
                    <span style={{ color: "red" }}>*</span>

                  </label>

                  <select
                    className="form-control"
                    value={selectedTime}
                    onChange={(e) => setSelectedTime(e.target.value)}
                  >
                    <option value="">Select Time</option>
                    {generateTimeOptions().map((time, index) => (
                      <option key={index} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div> */}

                <div className="col-6 field-div">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Description
                    <span style={{ color: "red" }}>*</span>

                  </label>
                  <textarea
                    type="text"
                    class="form-control"
                    value={Data.description}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setDestionErr("");
                    }}
                    required
                    name="description"
                    style={{
                      padding: "10px",
                    }}
                  ></textarea>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {descriptionsErr}
                  </p>
                </div>

                <div className="col-6 field-div ActiveStatusSub">
                  <label htmlFor="isActiveToggle" className="toggleLabel">Is Active                                          <input
                    type="checkbox"
                    id="isActiveToggle"
                    name="isActive"
                    onChange={() => {
                      Handletoggle(!Data.is_active);
                    }}

                    className="toggleInput"
                    checked={Data.is_active}
                  /></label>
                  <div className="toggleSwitch">

                    <span className="slider"></span>
                  </div>
                </div>

              </form>
              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >

                {/* <button
                  class="btn CancelBtn"
                  //  onClick={handleClose}
                  onClick={(e) => setShow(false)}
                >
                  Cancel
                </button> */}

                <button
                  class="btn  Createbuttonpop"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);
                    //   HandleEdits(e);
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InternalSubcategorycrud;
